/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const RealizationDepartmentDto = {
    Kitchen: 'KITCHEN',
    Pastry: 'PASTRY',
    Drinks: 'DRINKS',
    Equipment: 'EQUIPMENT',
    Service: 'SERVICE',
    Magazine: 'MAGAZINE',
    Decoration: 'DECORATION',
    Transport: 'TRANSPORT',
} as const;

export type RealizationDepartmentDto = typeof RealizationDepartmentDto[keyof typeof RealizationDepartmentDto];



